import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';

import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Redlining } from '../../core/models/classes/redlining';
import { RedliningService } from '../../core/services/redlining.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ObjectTypes, ObjectTypesen } from '../../core/models/enums/object-types';
import { WorkOrderModel } from '../../core/models/classes/work-order';
import { WorkorderService } from '../../core/services/work-order.service';
import { RedliningAcknowledgeModel } from '../../core/models/classes/acknowledgement';
import { Statustext } from '../../core/models/enums/status';
import { UserService } from '../../core/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Attachment } from '../../core/models/classes/attachment';
import { AttachmentComponent } from './attachment/attachment.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface DialogData {
  data: Redlining;
}

@Component({
  selector: 'app-redlining',
  templateUrl: './redlining.component.html',
  styleUrls: ['./redlining.component.scss'],
})

export class RedliningComponent implements OnInit, AfterViewInit {
  displayedRedColumns: string[] = [
    'select',
    'id',
    'objectType',
    'objectId',
    'subject',
    'content',
    'priorityText',
    'user',
    'createdDate',
    'details',
    'status',
  ];
  filterStatus: string[] = [$localize`All`, $localize`New`, $localize`Completed`];
  redLiningStatus: string[] = [$localize`New`, $localize`Completed`];
  redlinings: Redlining[] = [];
  redDataSource;
  errorMessage: string;
  reds: Observable<Redlining[]>;
  selectedRedlining: Redlining;
  selectedWorkOrderModel: WorkOrderModel;
  redliningSelection = new SelectionModel<Redlining>(false, []);
  currentWorkOrder: number = 0;
  selectedRedliningAttachment: Attachment[] = [];
  images: any[] = [];
  img: any;
  @ViewChild(MatSort) sort: MatSort;
  data: any;
  selectedImages: any[];
  rlAttachment: number = 0;
  deleteEnabled: string = '';
  access: boolean = false;
  selectionModel = new SelectionModel<Redlining>(true, []);
  redListTodelete: number[] = [];
  chosenStatus: string = $localize`All`;

  constructor(
    private RedliningService: RedliningService,
    private workOrderService: WorkorderService,
    private userService: UserService,
    private changeDetectorRefs: ChangeDetectorRef,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.redDataSource = new MatTableDataSource([]);
    this.selectedWorkOrderModel = new WorkOrderModel();
  }

  ngAfterViewInit(): void {
    this.redDataSource.sort = this.sort;
  }

  ngOnInit(): void {
    registerLocaleData(localeDe, 'de-DE', localeDeExtra);

    //identify logged in user
    var loggedInUser = localStorage.getItem('loginId');
    if (loggedInUser === '1') {
      this.access = true;
    } else {
      this.access = false;
    }

    this.getAllRedlinings();
  }

  getAllRedlinings() {
    this.RedliningService.getRedlinings().subscribe({
      next: (red) => {
        this.redlinings = red;
        this.getRedliningObjects(this.redlinings);
        if (this.redlinings !== undefined) {
          this.redlinings.forEach((x) => {
            if ($localize.locale === 'de') {
              x.objectType = ObjectTypes[x.objectType];
            } else {
              x.objectType = ObjectTypesen[x.objectType];
            }

            let idx = -1;
            if (x.status === 'neu' || x.status === 'New') {
              idx = 0;
            } else if (x.status === 'bestätigt' || x.status === 'Completed') {
              idx = 1;
            }
            x.status = this.redLiningStatus[idx];
          });
        }

        this.redDataSource.data = this.redlinings;
        this.getSortedRedlinings();       
      },
      error: (err) => {
        throw Error(err);
      },
    });
  }

  getSortedRedlinings(){
    this.redDataSource.sortingDataAccessor = (i, p) => {
      switch (p) {
        case 'createdDate':
          return new Date(i.createdDate);
        default:
          return i[p];
      }
    };
    this.sort.sort({ id: 'createdDate', start: 'desc' } as MatSortable);
    this.changeDetectorRefs.detectChanges();
  }

  refreshList() {
    this.RedliningService.getRedlinings().subscribe({
      next: (red) => {
        this.redlinings = red;
        this.getRedliningObjects(this.redlinings);
        if (this.redlinings !== undefined) {
          this.redlinings.forEach((x) => {
            if ($localize.locale === 'de') {
              x.objectType = ObjectTypes[x.objectType];
            } else {
              x.objectType = ObjectTypesen[x.objectType];
            }

            let idx = -1;
            if (x.status === 'neu' || x.status === 'New') {
              idx = 0;
            } else if (x.status === 'bestätigt' || x.status === 'Completed') {
              idx = 1;
            }
            x.status = this.redLiningStatus[idx];
          });
        }

        this.redDataSource.data = this.redlinings;
      },
      error: (err) => {
        throw Error(err);
      },
    });
  }

  selectRedlining(id: number) {
    let lid = localStorage.getItem('loginId');
    let ack = new RedliningAcknowledgeModel();
    ack.RedliningID = id;
    ack.UserID = +lid;
    let selected: Redlining = new Redlining();
    this.RedliningService.getRedlining(id).subscribe({
      next: (data) => {
        selected = data;
        selected.cSObjectId = this.getObjectDetails(data);
        this.RedliningService.ackRedlining(ack);
        // this.dialog.open(RedliningDialogComponent, {
        //   data: {
        //     selected,
        //   },
        //   panelClass: 'custom-dialog-container',
        // });
      },
    });
  }

  getRedliningObjects(reds: Redlining[]) {
    if (this.redlinings !== undefined) {
      this.redlinings.forEach(async (x) => {
        if (x !== undefined || x !== null) {
          let val = this.getObjectDetails(x);
          if (val !== undefined) {
            x.cSObjectId = val;
          } else {
            //identify new object
            if (x.newLocationGeometries != null) {
              if (x.newLocationGeometries.includes('x')) {
                x.cSObjectId = $localize`POINT`;
              } else if (x.newLocationGeometries.includes('rings')) {
                x.cSObjectId = 'POLYGON';
              } else if (x.newLocationGeometries.includes('paths')) {
                x.cSObjectId = $localize`LINE`;
              } else {
                x.cSObjectId = '-';
              }
            } else {
              x.cSObjectId = '-';
            }
          }
        }
      });
    }
  }

  getObjectDetails(item: Redlining): any {
    switch (+item.objectType) {
      case 0:
        this.getRedBuildings(item);        
        break;
      case 1:
        this.getRedTrenches(item);       
        break;
      case 2:
        this.getRedDucts(item);      
        break;
      case 3:
        this.getRedCables(item);      
        break;
      case 4:
        this.getRedFloors(item);      
        break;
      case 5:
        this.getRedRooms(item);       
        break;
      case 6:
        this.getRedRacks(item);    
        break;
      case 7:
        this.getRedComponents(item);       
        break;
      case 8:
        this.getRedComponentPorts(item);      
        break;
      case 9:
        item.priority = item.priorityText;
        this.fetchUser(item);
        break;
      case 10:
        item.priority = item.priorityText;
        this.fetchUser(item);
        break;
      case 11:
        this.getRedServices(item);      
        break;
    }
  }

  getRedTrenches(item: Redlining){
    this.RedliningService.getDuct(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[3]}`;
          item.priority = item.priorityText;
          this.fetchUser(item);
        }
      },
    });
  }

  getRedDucts(item: Redlining){
    this.RedliningService.getDuct(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[3]}`;
          item.priority = item.priorityText;
          this.fetchUser(item);
        }
      },
    });
  }

  getRedCables(item: Redlining){
    this.RedliningService.getCable(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[3]}|${
            Object.values(data)[5]
          }`;
        }
        item.priority = item.priorityText;
        this.fetchUser(item);
      },
    });
  }

  getRedFloors(item: Redlining){
    this.RedliningService.getFloor(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[2]}`;
          item.priority = item.priorityText;
          this.RedliningService.getBuilding(
            Object.values(data)[1]
          ).subscribe({
            next: (b) => {
              item.cSObjectId =
                `${Object.values(b)[1]} \\ ` + `${Object.values(data)[2]}`;
            },
          });
          this.fetchUser(item);
        }
      },
    });
  }

  getRedRooms(item: Redlining){
    this.RedliningService.getRoom(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.priority = item.priorityText;
          this.userService.getUser(item.userID).subscribe({
            next: (user) => {
              this.RedliningService.getFloor(
                Object.values(data)[1]
              ).subscribe({
                next: (f) => {
                  this.RedliningService.getBuilding(
                    Object.values(f)[1]
                  ).subscribe({
                    next: (b) => {
                      item.cSObjectId =
                        `${Object.values(b)[1]} \\ ` +
                        `${Object.values(f)[2]} \\ ` +
                        `${Object.values(data)[2]} `;
                    },
                  });
                },
              });
              item.user = user.name;
            },
          });
        }
      },
    });
  }

  getRedRacks(item: Redlining){
    this.RedliningService.getRack(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[2]}`;
          item.priority = item.priorityText;
          this.RedliningService.getRoom(Object.values(data)[1]).subscribe({
            next: (r) => {
              this.RedliningService.getFloor(
                Object.values(r)[1]
              ).subscribe({
                next: (f) => {
                  this.RedliningService.getBuilding(
                    Object.values(f)[1]
                  ).subscribe({
                    next: (b) => {
                      item.cSObjectId =
                        `${Object.values(b)[1]} \\ ` +
                        `${Object.values(f)[2]} \\ ` +
                        `${Object.values(r)[2]} \\ ` +
                        `${Object.values(data)[2]} `;
                    },
                  });
                },
              });
            },
          });
          this.fetchUser(item);
        }
      },
    });
  }

  getRedComponents(item: Redlining){
    this.RedliningService.getComponent(Object.values(item)[0]).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${data}`;
          item.priority = item.priorityText;
          this.fetchUser(item);
        }
      },
    });
  }

  getRedComponentPorts(item: Redlining){
    this.RedliningService.getComponentPort(
      Object.values(item)[0]
    ).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${data}`;
          item.priority = item.priorityText;
          this.fetchUser(item);
        }
      },
    });
  }

  getRedServices(item: Redlining){
    this.RedliningService.getService(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[2]}`;
          item.priority = item.priorityText;
          this.fetchUser(item);
        }
      },
    });
  }

  getRedBuildings(item: Redlining){
    this.RedliningService.getBuilding(item.objectID).subscribe({
      next: (data) => {
        if (data !== null) {
          item.cSObjectId = `${Object.values(data)[2]} | ${Object.values(data)[1]}`;
          item.priority = item.priorityText;
          this.fetchUser(item);
        }
      },
    });
  }

  fetchUser(item: Redlining){
    this.userService.getUser(item.userID).subscribe({
      next: (data) => {
        if (data !== null){
          item.user = data.name;
        }       
      },
    });
  }

  getBuildingId(id: number): any {
    this.RedliningService.getBuilding(id).subscribe({
      next: (data) => {
        return Object.values(data)[2];
      },
      error: (err) => {
        throw Error(err.status);
      },
    });
  }

  loadAttachment(id: number) {
    this.rlAttachment = id;
    this.showAttachments();  
  }

  showAttachments(): void {
    var sources = this.rlAttachment;
    this.dialog.open(AttachmentComponent, {
      data: {
        sources,
      },
      panelClass: 'custom-dialog-container',
    });
  }

  filterRedlinings(event: Event) {
    this.selectionModel.clear();
    this.redListTodelete = [];
    this.redDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
  }

  isAllSelected() {
    const numSelected = this.selectionModel.selected.length;
    const numRows = this.redDataSource.data.length;
    this.deleteEnabled = 'Delete enabled';
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selectionModel.clear();
      return;
    }
    this.selectionModel.select(...this.redDataSource.data);
  }

  add(row: Redlining, value: MatCheckboxChange) {
    this.redListTodelete = [];
    if (value.checked === true) {
      if (this.selectionModel.selected.find((x) => x.id === row.id)) {
        this.deleteEnabled = 'Delete enabled';
      }
    } else {
      if (this.selectionModel.selected.length === 0) {
        this.deleteEnabled = '';
      } else {
        this.deleteEnabled = 'Delete enabled';
      }
    }

    if (this.selectionModel.selected.length !== 0) {
      const result = this.selectionModel.selected.map((item) => item.id);
      this.redListTodelete = result;
    }
  }

  onStatusSelected(val) {
    let lid = localStorage.getItem('loginId');
    let ack = new RedliningAcknowledgeModel();
    ack.RedliningID = val.id;
    ack.UserID = +lid;
    var idx = this.redLiningStatus.indexOf(val.status);
    ack.Status = Statustext[Statustext[idx]];
    this.RedliningService.ackRedlining(ack).subscribe({
      next: (data) => {
        if (data.status === 200) {
        }
      },
      error: (err) => {
        throw Error(err);
      },
    });
  }

  onGetStatus(val) {}

  onFilter(item: string){
    this.selectionModel.clear();
    this.redListTodelete = []; //clear items selected to delete

    this.chosenStatus = item;
    if(item == $localize`New`){
      this.redDataSource.data = this.redlinings.filter(x => x.status == $localize`New`);
    }
    else if(item == $localize`Completed`){
      this.redDataSource.data = this.redlinings.filter(x => x.status == $localize`Completed`);
    }
    else{
      this.redDataSource.data = this.redlinings;
    }
  }

  onDelete() {
    this.deleteEnabled = ''; //disable delete button click
    if (this.redListTodelete.length !== 0) {
      this.RedliningService.deleteRedlining(this.redListTodelete).subscribe({
        next: (data) => {
          if (data.status === 200) {
            this.refreshList();

            this._snackBar.open(
              $localize`Selected Redlinings deleted successfully`,
              '',
              {
                duration: 3000,
              }
            );
          }
        },
        error: (err) => {
          this._snackBar.open(
            $localize`Failed to delete selected redlinings`,
            '',
            {
              duration: 3000,
            }
          );         
        },
      });
      this.redListTodelete = []; //clear items in the list
    } else {
      this._snackBar.open($localize`No redlinings selected to delete`, '', {
        duration: 3000,
      });
    }
  }
}
